import React from 'react';
export default function CastingPositionPlane({ children }: { children?: React.ReactNode }) {
  return <div className="casting-plane">
    <div className="casting-plane__label"><span>Y 演奏難易度（易 → 難）</span></div>
    <div className="casting-plane__canvas">
      <strong className="casting-plane__pole casting-plane__pole--hard">難 ↑</strong>
      <div className="casting-plane__x" aria-hidden="true" /><div className="casting-plane__y" aria-hidden="true" />{children}
      <strong className="casting-plane__pole casting-plane__pole--easy">易 ↓</strong>
    </div>
    <div className="casting-plane__label casting-plane__genre"><span>X ジャンル</span></div>
    <div className="casting-plane__label casting-plane__ends"><span>ポップスライク ←</span><strong>→ クラシックライク</strong></div>
  </div>;
}
